<template>
  <v-flex xs12 sm8 md4>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
         <v-toolbar-title>Forgotten Password</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form v-if="!emailSent" ref="form-2">
          <v-text-field
          v-model="user.email"
          :rules="emailRules"
          prepend-icon="person"
          required
          validate-on-blur
          name="E-mail"
          label="E-mail"
          type="text">
          </v-text-field>
        </v-form>
        <p
        v-if="emailSent"
        class="subtitle is-6">
        We will send further instructions to the email you provided,
        if it is linked to an account.</p>
      </v-card-text>
      <v-card-actions>
        <v-card-text
        v-if="!emailSent"
        @click="goToLogin()"
        @keyup.enter="goToLogin()"
        role="button">Go back to login?</v-card-text>
        <v-spacer></v-spacer>
         <v-btn
         v-if="!emailSent"
         color="primary" @click="forgot($event)">Help Me</v-btn>
         <v-btn
         v-if="emailSent"
         color="primary" @click="goToLoginReset()">Okay</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>
<script>
import LoginFunctions from '../controllers/Login';

export default {
  name: 'LoginForgot',
  // data: () => ({
  data() {
    return {
      drawer: null,
      emailSent: false,
      user: {
        email: '',
        password: '',
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid',
      ],

    };
  },
  props: {
    source: String,
  },
  created() {
  },
  mounted() {
  },
  methods: {
    /**
    * To go to the login form.
    * @function
    * @returns {undefined}
    */
    goToLogin() {
      this.$router.push('login');
    },
    /**
    * To go to the login reset form.
    * @function
    * @returns {undefined}
    */
    goToLoginReset() {
      const data = { reset: true };
      this.$store.dispatch('SET_RESET_PASSWORD', data);
      this.$router.push('login');
    },
    /**
    * To prompt the backend call that sends the user a password reset after forgetting password.
    * @function
    * @param {object} event - The click event that prompted this function.
    * @returns {object} A promise that will either return an error message or display the
    * success screen
    */
    forgot() {
      if (this.$refs['form-2'].validate()) {
        LoginFunctions.forgot(this.user.email)
          .then(() => {
            this.emailSent = true;
            this.$forceUpdate();
          })
          .catch((reason) => {
            if (reason.response.data.declaration === 'auth_token_needs_refresh') {
              this.$emit('snackbar', 'Sorry, try again');
            } else {
              console.log(reason);
            }
          });
      } else {
        this.$emit('snackbar', 'Sorry, try again');
      }
    },
  },
};
</script>
<style></style>
